import React from 'react';
import NavBar from '../components/NavBar/navBar.component'
import Contact from '../components/Contact/contact.component'
import Footer from '../components/Footer/footer.component'

function Support() {
  return (
    <> 
      <NavBar/>
      <Contact/>
      <Footer/>
    </>
  )
}

export default Support